// Middleware hook: Redirects to log in if user is not authenticated
import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { AppRoute } from '@ts-routes/enums'

import { useAuthStore } from '@stores/auth'
import { useCustomerStore } from '@stores/me/customer'

import { getHomePageRoute } from '@auth/get-home-page-route'

import { navigateTo } from '#app'

export const useMiddlewareAuth = async (to: RouteLocationNormalizedGeneric) => {
  const auth = useAuthStore()
  const customerStore = useCustomerStore()

  if (!auth.accessToken) auth._hydrateFromStorage()

  const isLogin = to.path === AppRoute.Login

  const url = customerStore.customer
    ? getHomePageRoute(customerStore.customer)
    : null

  if (auth.accessToken && auth.secondsLeft() > 0) {
    if (isLogin) return navigateTo(url)
    await customerStore.ensure({ background: true })
    return
  }

  if (auth.refreshToken) {
    const token = await auth.refreshTokens()
    await customerStore.ensure({ background: true })

    const url = customerStore.customer
      ? getHomePageRoute(customerStore.customer)
      : null

    if (token) {
      if (isLogin) return navigateTo(url)
      return
    }
  }

  if (!isLogin) return navigateTo(AppRoute.Login)
}
